class BsAboutNewsletterModal {
  constructor(container) {
    this.container = container;
    this.modal = container.querySelector("[data-bs-about-newsletter-modal]");
    this.openButtons = container.querySelectorAll("[data-bs-about-newsletter-open]");
    this.closeButtons = container.querySelectorAll("[data-bs-about-newsletter-close]");
    this.focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    this.previousFocus = null;

    if (!this.modal || this.openButtons.length === 0) return;

    this.handleKeydown = this.handleKeydown.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);

    this.openButtons.forEach((button) => button.addEventListener("click", this.open));
    this.closeButtons.forEach((button) => button.addEventListener("click", this.close));
    this.modal.addEventListener("click", (event) => {
      if (event.target === this.modal) this.close();
    });

    const hashTarget = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
    if (hashTarget && this.modal.contains(hashTarget)) this.open();
  }

  open() {
    this.previousFocus = document.activeElement;
    this.modal.style.setProperty("--m-opacity", "1");
    this.modal.classList.add("m-open-modal");
    document.documentElement.classList.add("prevent-scroll");
    document.addEventListener("keydown", this.handleKeydown);

    const emailInput = this.modal.querySelector('input[type="email"]');
    const firstFocusable = emailInput || this.modal.querySelector(this.focusableSelector);
    if (firstFocusable) firstFocusable.focus();
  }

  close() {
    this.modal.classList.remove("m-open-modal");
    this.modal.style.setProperty("--m-opacity", "0");
    document.documentElement.classList.remove("prevent-scroll");
    document.removeEventListener("keydown", this.handleKeydown);

    if (this.previousFocus && typeof this.previousFocus.focus === "function") {
      this.previousFocus.focus();
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
      return;
    }

    if (event.key !== "Tab") return;

    const focusable = Array.from(this.modal.querySelectorAll(this.focusableSelector));
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

document.querySelectorAll(".bs-about-newsletter").forEach((section) => {
  new BsAboutNewsletterModal(section);
});
